import * as React from "react";
import { render } from "react-dom";
import App from "./filter-component";
import FilterHorizontal from "./filter-component-horizontal";
import ProductGrid from "./product-grid";
import RecentProducts from "./recent-products";
import ImageModal from "./image-modal";

declare var $: any;
declare var ICWidgets: any;

$(document).ready(() => {
  ICWidgets.Client.on("init-complete", (appRoutes: any) => {
    const filterWidget: any = document.getElementById("filter");
    filterWidget && render(<App />, filterWidget);

    const filterWidgetHorizontal: any = document.getElementById(
      "filter-horizontal"
    );
    filterWidgetHorizontal &&
      render(<FilterHorizontal />, filterWidgetHorizontal);

    const recentProducts: any = document.getElementById("recent-products");
    recentProducts && render(<RecentProducts />, recentProducts);

    const filterProducts: any = document.getElementById("filter-products");
    if (filterProducts) {
      const homepageMode =
        filterProducts.getAttribute("data-homepage-mode") === "true";
      render(<ProductGrid homepageMode={homepageMode} />, filterProducts);
    }
  });
});
